import { Fragment, useEffect, useRef, useState } from 'react';
import { ReactComponent as Parrot } from '../../../assets/images/Parrot_excited_3.svg';
import facebookOpenBrowser from '../../../assets/images/social-images/facebook-open-in-browser.jpg';
import facebookOptions from '../../../assets/images/social-images/facebook-options.jpg';
import instagramOpenBrowser from '../../../assets/images/social-images/instagram-open-in-browser.jpg';
import instagramOptions from '../../../assets/images/social-images/instagram-options.jpg';
import useAnalyticsEventTracker from '../../../hooks/use-analytics';
import { ReactComponent as AppleShare } from '../../../assets/icons/share-apple.svg';
import { ReactComponent as AddToHomeScreen } from '../../../assets/icons/plus-square.svg';
import {Trans, useTranslation} from 'react-i18next';

const DownloadCheck = () => {
  const {t: translate } = useTranslation();
  const [showPWA, setShowPWA] = useState(false);

  const createCookie = (installed) => {
    let date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000); //1 day -> 24 hours * 60 minutes * 60 seconds * 1000 (to get to milliseconds)
    let expires = 'expires=' + date.toGMTString();
    document.cookie = `gopwa=${installed}; ${expires}; path=/`;
  };

  // Detects if device is in standalone mode
  // const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
  const isInWebAppiOS = window.navigator.standalone === true;
  const isInWebAppChrome = window.matchMedia(
    '(display-mode: standalone)',
  ).matches;

  // If in standalone lets exit early
  if (isInWebAppiOS || isInWebAppChrome) {
    // console.log('standalone')
    createCookie(true);
    return null;
  }

  const addBtn = useRef();
  const [blurb, setBlurb] = useState([]);
  const [pwaTitle, setPwaTitle] = useState();
  const gaSocialBrowserTracker = useAnalyticsEventTracker('Social-Browser');
  const isIos = () => {
    let isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') == -1 &&
      navigator.userAgent.indexOf('FxiOS') == -1;

    let isIOSChrome = window.navigator.userAgent.match('CriOS');
    let isIOSFirefox = window.navigator.userAgent.match('FxiOS');

    if (isIOSChrome) return 'CriOS';
    if (isIOSFirefox) return 'FxiOS';

    return isSafari;
  };

  let isTouchScreen = window.matchMedia('(pointer:coarse)').matches;
  //Deals with desktop
  //Has to be after hooks delcared to ensure react the order of the hooks being called
  if (!isTouchScreen) {
    return null;
  }

  const isSocialApp = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let isInstagram = userAgent.indexOf('Instagram') > -1 ? true : false;
    let isFacebook =
      userAgent.indexOf('FBAN') > -1 || userAgent.indexOf('FBAV') > -1;

    if (isInstagram) return 'instagram';
    if (isFacebook) return 'facebook';

    return false;
  };

  if( isSocialApp() === 'instagram' || isSocialApp === 'facebook' ) {
    gaSocialBrowserTracker('social-browser-detected');
  }

  let socialOptions =
    isSocialApp() === 'instagram' ? instagramOptions : facebookOptions;
  let socialBrowser =
    isSocialApp() === 'instagram' ? instagramOpenBrowser : facebookOpenBrowser;

  const socialAppInstructions = () => {
    return (
      <Fragment>
        <ul className="browser-steps">
          <li>
            <strong>{translate('step-1')}:</strong> {translate('open-settings')}
            <img
              src={socialOptions}
              alt="Browser Options (three dots in action bar)"
              title="Browser Options (three dots in action bar)"
            />
          </li>
          <li>
            <strong>{translate('step-2')}:</strong> {translate('open-in-browser')}
            <img
              src={socialBrowser}
              alt={translate('open-in-browser')}
              title={translate('open-in-browser')}
            />
          </li>
          <li>
            <strong>{translate('step-3')}: {translate('chat-new-lang')}</strong>
          </li>
        </ul>
      </Fragment>
    );
  };

  const iosInstructions = () => {
    if (isSocialApp() === 'instagram' || isSocialApp() === 'facebook') return;
    return (
      <Fragment>
        <ol>
          {(isIos() === 'CriOS' || isIos() === 'FxiOS') && (
            <li>{translate('open-in-safari')}</li>
          )}
          <li>
            <Trans i18nKey="tap-share-apple"> 
              <AppleShare />
            </Trans>
          </li>
          <li>
            <Trans  i18nKey="add-to-homescreen-apple">
              <AddToHomeScreen />
            </Trans>
          </li>
        </ol>
      </Fragment>
    );
  };

  useEffect(() => {
    //Hide download button by default
    addBtn.current.style.display = 'none';

    // let pwaCookie = null;
    // let match = document.cookie.match(new RegExp('(^| )gopwa=([^;]+)'));
    // if (match) {
    //   pwaCookie = match[2];
    // }

    // if (pwaCookie !== 'true' && isSocialApp() === false) {
    //   let deferredPrompt;

    //   if (isIos() !== false) {
    //     setPwaTitle(translate('download-web-app'));
    //     setBlurb([
    //       translate('download-blurb-1'),
    //       translate('download-blurb-2'),
    //     ]);
    //     setShowPWA(true);
    //   } else {
    //     window.addEventListener('beforeinstallprompt', (e) => {
    //       // Prevent Chrome 67 and earlier from automatically showing the prompt
    //       e.preventDefault();
    //       //Update UI to show download button as we know we can actually install the PWA
    //       setShowPWA(true);
    //       addBtn.current.style.display = 'block';
    //       setBlurb([
    //         translate('download-blurb-1'),
    //         translate('download-pwa'),
    //       ]);
    //       setPwaTitle(translate('download-web-app'));
    //       createCookie(false);
    //       // Stash the event so it can be triggered later.
    //       deferredPrompt = e;
    //       // Update UI to notify the user they can add to home screen

    //       addBtn.current.addEventListener('click', () => {
    //         // hide our user interface that shows our A2HS button
    //         // Show the prompt
    //         deferredPrompt.prompt();
    //         // Wait for the user to respond to the prompt
    //         deferredPrompt.userChoice.then((choiceResult) => {
    //           if (choiceResult.outcome === 'accepted') {
    //             console.log('User accepted the A2HS prompt');
    //           } else {
    //             console.log('User dismissed the A2HS prompt');
    //           }
    //           setShowPWA(false);
    //           deferredPrompt = null;
    //         });
    //       });
    //     });
    //   }
    // } else {
    //   setShowPWA(false);
    // }

    if (isSocialApp() === 'instagram' || isSocialApp() === 'facebook') {
      setShowPWA(true);
      setPwaTitle(translate('pardon-interuption'));
      setBlurb([
        translate('unsupported-browser'),
        translate('unsupported-browser-steps'),
      ]);
    }

    window.addEventListener('appinstalled', function () {
      createCookie(true);
    });
  }, []);

  return (
    <div
      className={`${showPWA ? 'pwa-screen pwa-screen--active' : 'pwa-screen'}`}
    >
      <div className="pwa-screen__content">
        {<Parrot />}
        <h1 className="pwa-screen__title">{pwaTitle}</h1>
        {blurb.map((line, index) => {
          return <p key={index}>{line}</p>;
        })}
        {isIos() !== false && iosInstructions()}
        <button
          id="add-to-homescreen"
          ref={addBtn}
          className="button button--success"
        >
          {translate('get-golingo')}
        </button>
        {isSocialApp() !== false && socialAppInstructions()}
        {isSocialApp() === false && (
          <button
            className="button button--alt button--tiny"
            onClick={() => {
              createCookie(true);
              setShowPWA(false);
            }}
          >
            {translate('no-pwa')}
          </button>
        )}
      </div>
    </div>
  );
};

export default DownloadCheck;
